import React, { useState } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { downloadCsvWorkOrdersPath } from 'routes';
import api from '@utils/axios';

const namespace = 'features.work_orders.index';

function ExportCsv({ workOrderIds, disabled, queryParams }) {
  const [loading, setLoading] = useState(false);
  const usedParams = new URLSearchParams(queryParams);

  const onSubmit = async () => {
    setLoading(true);
    if (workOrderIds) {
      usedParams.append('ids', workOrderIds);
    } else {
      usedParams.append('all', true);
    }

    api
      .get(`${downloadCsvWorkOrdersPath({ format: 'json' })}?${usedParams}`)
      .then(({ data }) => {
        toast.success(data.message);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <button type="button" tabIndex="0" className="qmb-control" disabled={disabled || loading} onClick={onSubmit}>
      {loading ? <i className="fa-light fa-spinner-third fa-spin" /> : <i className="fa-light fa-file-export" />}
      {translate('export_csv_button', { namespace })}
    </button>
  );
}

ExportCsv.propTypes = {
  workOrderIds: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool.isRequired,
  queryParams: PropTypes.object.isRequired
};

ExportCsv.defaultProps = {
  workOrderIds: null
};

export default ExportCsv;
